/**
 * Copyright (c) [2026] SUSE Linux
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */

import { useState, useCallback } from 'react';

let toastId = 0;

function useToast() {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(({ type = 'info', message, duration = 1500, showClose = true }) => {
    const id = ++toastId;
    const newToast = {
      id,
      type,
      message,
      duration,
      showClose,
    };
    
    setToasts((prev) => [...prev, newToast]);
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const info = useCallback((message, options = {}) => 
    addToast({ type: 'info', message, ...options }), [addToast]);
  
  const success = useCallback((message, options = {}) => 
    addToast({ type: 'success', message, ...options }), [addToast]);
  
  const warning = useCallback((message, options = {}) => 
    addToast({ type: 'warning', message, ...options }), [addToast]);
  
  const error = useCallback((message, options = {}) => 
    addToast({ type: 'error', message, ...options }), [addToast]);

  const clearAll = useCallback(() => {
    setToasts([]);
  }, []);

  return {
    toasts,
    addToast,
    removeToast,
    info,
    success,
    warning,
    error,
    clearAll,
  };
}

export default useToast;